import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import status_icon from "../../assets/icons/status_icon.png";
import { Link } from "react-router-dom";

const Configuration = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-6">
        <Link to="/profile/status-vertical">
          <div className="flex items-start border-2 rounded-lg p-4 w-[90%]">
            <img
              src={status_icon}
              alt="status vertical"
              className="object-contain"
            />
            <div className="ml-4">
              <p className="text-[18px] font-bold">Status Vertical</p>
              <p className="text-[#828282] text-[14px] italic mt-4">
                Personalized configurations at your fingertips
              </p>
            </div>
          </div>
        </Link>
        <div className="">
          <div className="mt-6 flex justify-between w-[90%] config-col">
            <div className="w-[49%] config-width">
              <p className="text-[14px] text-[#828282]">
                Automatically close prospects if no communication occurs within
                how many days?
              </p>
              <input
                type="text"
                placeholder="Enter the days"
                className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
              />
            </div>
            <div className="w-[49%] config-width">
              <p className="text-[14px] text-[#828282]">
                In how many days should the system escalate to another user if
                the sales user takes no action?
              </p>
              <input
                type="text"
                placeholder="Enter the days"
                className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
              />
            </div>
          </div>

          <div className="mt-4 flex justify-between w-[90%] config-col">
            <div className="w-[49%] config-width">
              <p className="text-[14px] text-[#828282]">
                Set a reminder for the meeting in advance?
              </p>
              <input
                type="text"
                placeholder="Enter the days"
                className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
              />
            </div>
            <div className="w-[49%] config-width">
              <p className="text-[14px] text-[#828282]">
                How many days does the user have to follow up after entering a
                prospect?
              </p>
              <input
                type="text"
                placeholder="Enter the days"
                className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
              />
            </div>
          </div>
          <div className="mt-4 flex justify-between w-[90%]">
            <div className="w-[49%] config-width">
              <p className="text-[14px] text-[#828282]">
                Initiate contact if inactive for a specified duration
              </p>
              <input
                type="text"
                placeholder="Enter the days"
                className="text-[16px] border w-full border-[#95C2FF] p-2 rounded-lg"
              />
            </div>
          </div>
        </div>

        <div className="my-8 flex w-[90%] justify-end items-center create-foot">
          <div className="flex text-[14px] w-[50%] justify-end">
            <button className=" bg-white text-[#2F80ED] font-bold border border-[#95C2FF] p-2 rounded-lg w-[40%]">
              Discard
            </button>
            <button className=" bg-[#2F80ED] ml-2 p-2 text-white rounded-lg w-[40%]">
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Configuration;
